import _ from "lodash";
import { EMPTY_CELL } from "../constants";
import { htmlToText } from "Utils/HTMLHelpers";

const getRowCollapseCellProps = ({ node, cellConfig, customConfig }) => {
  const { styles } = cellConfig || {};
  const {
    property,
    showEmptyCellAsFallback,
    valueIdentifier,
    isValueInArray = false,
    getValue,
  } = customConfig || {};

  let value = _.get(node, property) || "";

  if (isValueInArray) {
    const foundValue = _.find(value, valueIdentifier);
    value = getValue(foundValue);
  }

  if (!value && showEmptyCellAsFallback) return { ...EMPTY_CELL, styles };

  const options = {
    wordwrap: false,
    preserveNewlines: true,
  };
  return {
    ...cellConfig,
    value: htmlToText(value, options),
  };
};

export default getRowCollapseCellProps;
